function _ctDocSelecionado(input){
  const file=input.files[0];
  if(!file)return;
  document.getElementById('ct-doc-nome').textContent=file.name;
  document.getElementById('ct-ocr-btn').style.display='';
  const reader=new FileReader();
  reader.onload=e=>{
    window._ctDocDataUrl=e.target.result;
    if(file.type.startsWith('image/')){
      document.getElementById('ct-doc-img').src=e.target.result;
      document.getElementById('ct-doc-preview').style.display='';
    }
  };
  reader.readAsDataURL(file);
}

async function _ctLerDocumento(){
  if(!window._ctDocDataUrl){toast('Selecione um documento primeiro','warn');return;}
  const status=document.getElementById('ct-ocr-status');
  const btn=document.getElementById('ct-ocr-btn');
  status.style.display='';
  status.textContent='Carregando motor de leitura de texto...';
  btn.disabled=true;
  try{
    if(!window.Tesseract){
      await new Promise((res,rej)=>{
        const s=document.createElement('script');
        s.src='https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js';
        s.onload=res;s.onerror=()=>rej(new Error('Falha ao carregar Tesseract.js'));
        document.head.appendChild(s);
      });
    }
    status.textContent='Lendo documento, isso pode levar alguns segundos...';
    const worker=await Tesseract.createWorker('por');
    const {data:{text}}=await worker.recognize(window._ctDocDataUrl);
    await worker.terminate();
    status.textContent='Processando informações extraídas...';
    _ctPreencherOCR(text);
    status.textContent='✓ Leitura concluída. Verifique e corrija os campos se necessário.';
  }catch(e){
    status.textContent='Erro ao ler documento: '+e.message;
    toast('Erro no OCR: '+e.message,'error');
  }finally{
    btn.disabled=false;
  }
}

function _ctPreencherOCR(text){
  // CPF: 000.000.000-00
  const cpfM=text.match(/\d{3}[.\s]\d{3}[.\s]\d{3}[-\s]\d{2}/);
  if(cpfM){const el=document.getElementById('ct-cpf');if(!el.value)el.value=cpfM[0].replace(/\s/g,'');}
  // Nome completo (linha após "Nome" ou "Nome completo")
  const nomeM=text.match(/Nome(?:\s+completo)?[:\s]+([A-ZÁÉÍÓÚÀÂÊÔÃÕÜÇÑ][A-ZÁÉÍÓÚÀÂÊÔÃÕÜÇÑa-záéíóúàâêôãõüçñ\s]{4,60})/i);
  if(nomeM){const el=document.getElementById('ct-nome');if(!el.value)el.value=nomeM[1].trim();}
  // Tipo do documento
  const tipoEl=document.getElementById('ct-doc-tipo');
  if(!tipoEl.value){
    if(/CARTEIRA NACIONAL DE HABILITA/i.test(text))tipoEl.value='CNH';
    else if(/CARTEIRA DE IDENTIDADE NACIONAL|CIN/i.test(text))tipoEl.value='CIN';
  }
  // CEP no texto
  const cepM=text.match(/\d{5}-\d{3}/);
  if(cepM){const el=document.getElementById('ct-end-cep');if(!el.value){el.value=cepM[0];buscarCepContrato(cepM[0]);}}
  toast('Documento lido. Verifique os campos preenchidos','info');
}

function _abrirContratoImprimivel(titulo,html){
  const styleMatch=html.match(/<style[^>]*>([\s\S]*?)<\/style>/i);
  const bodyMatch=html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
  const conteudo=`${styleMatch?`<style>${styleMatch[1]}</style>`:''}${bodyMatch?bodyMatch[1]:html}`;
  abrirDocumentoImpressao(titulo,conteudo);
}

function previewContrato(){
  const data=_coletarDadosContrato();
  if(!data.contratante.nome){toast('Preencha o nome do contratante','error');return;}
  if(!data.contratada.nome||!data.contratada.cnpj){toast('Configure razão social/nome e CNPJ da empresa antes de gerar contrato.','error');showPage('config');return;}
  const html=_buildContratoHTML(data);
  _abrirContratoImprimivel(`Contrato - ${data.contratante.nome}`,html);
}

async function _criarTarefaEntregaContrato(data){
  try{
    const diasUteis=parseInt(data.prazo.dias)||30;
    const dataBaseISO=document.getElementById('ct-data-contrato').value||today();
    const dataEntrega=addDiasUteis(dataBaseISO,diasUteis);
    const pedidoId=document.getElementById('ct-pedido-id').value;
    const p=pedidoId?(DB.get('pedidos').find(x=>x.id===pedidoId)||{}):null;
    const desc=`📦 Entrega — Pedido #${p?.num||'?'} (${data.contratante.nome||'—'}) · ${diasUteis}du → ${fmtD(dataEntrega)}`;
    const novaTarefa={id:uid(),desc,data:dataEntrega,prioridade:'alta',done:false,criadoEm:new Date().toISOString()};
    const lista=[...(CACHE.tarefas||[]),novaTarefa];
    await DB.set('tarefas',lista);
    toast(`🗓️ Prazo de entrega adicionado às Rotinas para ${fmtD(dataEntrega)}`,'success');
  }catch(e){console.error('_criarTarefaEntregaContrato',e);}
}
async function gerarEEnviarContrato(){
  const data=_coletarDadosContrato();
  if(!data.contratante.nome||!data.contratante.cpf){toast('Preencha nome e CPF do contratante','error');switchCtTab(0);return;}
  if(!data.financeiro.valor){toast('Preencha o valor total do contrato','error');switchCtTab(2);return;}
  if(Math.abs((data.financeiro.entrada+data.financeiro.saldo)-data.financeiro.valor)>0.02){toast('Entrada + saldo precisa fechar com o valor total do contrato','error');switchCtTab(2);return;}
  if(!(data.local.enderecoObra||data.contratante.enderecoCompleto)){toast('Preencha o endereço de instalação ou o endereço do contratante','error');switchCtTab(0);return;}
  if(!data.contratada.nome||!data.contratada.cnpj){toast('Configure razão social/nome e CNPJ da empresa antes de gerar contrato.','error');showPage('config');return;}
  const ac=_clicksignCfg();
  if(!ac.backendConfigured){
    toast('ClickSign não registrado, gerando contrato para download...','warn');
    const html=_buildContratoHTML(data);
    _abrirContratoImprimivel(`Contrato - ${data.contratante.nome}`,html);
    const _pidLocal=document.getElementById('ct-pedido-id')?.value;
    if(_pidLocal){const _pLocal=(CACHE.pedidos||DB.get('pedidos')||[]).find(x=>x.id===_pidLocal);if(_pLocal&&!_pLocal.contratoGeradoEm){const _upd={..._pLocal,contratoGeradoEm:new Date().toISOString()};const _pedidos=DB.get('pedidos').map(x=>x.id===_pidLocal?_upd:x);await DB.set('pedidos',_pedidos);}}
    await _criarTarefaEntregaContrato(data);
    closeModal('modal-contrato');
    return;
  }
  const pedidoId=document.getElementById('ct-pedido-id').value;
  const p=pedidoId?DB.get('pedidos').find(x=>x.id===pedidoId):null;
  const c=p?DB.get('clientes').find(x=>x.id===p.clienteId)||{}:{};
  const rawTel=(c.whatsapp||c.tel||p?.tel||'').replace(/\D/g,'');
  const email=(c.email||p?.email||'').trim();
  if(!rawTel&&!email){toast('O cliente precisa ter e-mail ou WhatsApp cadastrado para envio automático','error');return;}
  const cpf=(data.contratante.cpf||c.cpf||c.cpfcnpj||'').replace(/\D/g,'');
  if(!/^\d{11}$/.test(cpf)){toast('A ClickSign exige CPF válido do contratante para assinatura. Complete o cadastro/contrato.','error');return;}
  toast('⏳ Gerando PDF do contrato...');
  const html=_buildContratoHTML(data);
  const pdfBase64=await _pdfGerarBase64(html,{marginTop:16,marginBottom:20,marginLeft:18,marginRight:18});
  // Guarda de segurança: com o renderer de texto real, uma página em branco fica em
  // torno de 3 KB e qualquer contrato com conteúdo real passa de ~25 KB. 8 KB dá
  // margem confortável dos dois lados sem bloquear contratos legitimamente curtos.
  if(Math.floor(pdfBase64.length*3/4)<8000){
    toast('O PDF do contrato saiu vazio/incompleto. Envio cancelado por segurança. Feche outras abas pesadas e tente gerar novamente.','error');
    return;
  }
  let docParaAssinaturaBase64=pdfBase64,nomeArquivoAssinatura=`Contrato_${data.contratante.nome.replace(/[^a-zA-Z0-9_-]/g,'_')}.pdf`;
  if(p){
    try{
      toast('📎 Anexando orçamento ao contrato...');
      const orcamentoBase64=await _gerarPDFBase64(pedidoId);
      if(Math.floor(orcamentoBase64.length*3/4)<8000)throw new Error('PDF do orçamento saiu vazio/incompleto.');
      const mergedBase64=await _mergePdfsBase64([pdfBase64,orcamentoBase64]);
      if(Math.floor(mergedBase64.length*3/4)<Math.floor(pdfBase64.length*3/4))throw new Error('PDF combinado saiu menor que o contrato original.');
      docParaAssinaturaBase64=mergedBase64;
      nomeArquivoAssinatura=`Contrato_Orcamento_${data.contratante.nome.replace(/[^a-zA-Z0-9_-]/g,'_')}.pdf`;
    }catch(e){
      console.error('Falha ao anexar orçamento ao contrato',e);
      toast('Não foi possível anexar o orçamento ao PDF; enviando apenas o contrato.','warn');
    }
  }
  toast('📤 Criando envelope ClickSign...');
  const wNum=rawTel?'+55'+rawTel.replace(/^55/,''):'';
  try{
    const apiData=await _callClicksignIntegration('createClicksignSignatureRequest',{
      recipient_name:data.contratante.nome,
      recipient_cpf:cpf,
      recipient_whatsapp:wNum,
      recipient_email:email,
      pdf_base64:docParaAssinaturaBase64,
      envelope_name:`Contrato ${p?.num||pedidoId||data.contratante.nome} - ${data.contratante.nome}`,
      message:'Seu contrato está disponível para assinatura pela ClickSign.',
      filename:nomeArquivoAssinatura
    });
    if(p){
      const updated={...p,assinaturaProvider:'clicksign',clicksignEnvelopeId:apiData.envelope_id,clicksignDocumentId:apiData.document_id,clicksignSignerId:apiData.signer_id,clicksignStatus:apiData.status||'running',clicksignEnviadoEm:new Date().toISOString(),clicksignContato:wNum||email};
      const pedidos=DB.get('pedidos').map(x=>x.id===pedidoId?updated:x);
      await DB.set('pedidos',pedidos);
    }
    await _criarTarefaEntregaContrato(data);
    toast('✅ Envelope ClickSign criado e notificado.','success');
    closeModal('modal-contrato');
  }catch(e){toast('Erro ao enviar contrato: '+(e.message||e),'error');}
}

